import rootReducer from '../reducers';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { createStore, compose, applyMiddleware } from 'redux';
import { reactReduxFirebase, getFirebase } from 'react-redux-firebase';
import firebase from 'firebase';
import { reduxFirestore } from 'redux-firestore';
import 'firebase/firestore';
import GeoFire from 'geofire';
import initialState from '../initialState';
import logger from 'redux-logger';

const firebaseConfig = {
  apiKey: process.env["REACT_APP_FIREBASE_API_KEY"],
  authDomain: process.env["REACT_APP_FIREBASE_AUTH_DOMAIN"],
  databaseURL: process.env["REACT_APP_FIREBASE_DB_URL"],
  projectId: process.env["REACT_APP_FIREBASE_PROJECT_ID"],
  storageBucket: process.env["REACT_APP_FIREBASE_STORAGE_BUCKET"],
  messagingSenderId: process.env["REACT_APP_FIREBASE_MESSAGING_SENDER_ID"],
};

const rrfConfig = {
  userProfile: 'users',
  attachAuthIsReady: true,
};

firebase.initializeApp(firebaseConfig);
firebase.firestore();
let database = firebase.database.Reference;

let geoFire = new GeoFire(firebase.database().ref().child('geoIndices'));

const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig),
)(createStore);

const configureStore = function (initialState, createStoreWithFirebase) {
  return createStoreWithFirebase(
    rootReducer,
    Object.assign({}, initialState, {
      geoFire,
      database
    }),
    applyMiddleware(
      reduxImmutableStateInvariant(),
      // logger,
      thunk
    )
  );
}

const store = configureStore(initialState, createStoreWithFirebase);

export default store;



// WEBPACK FOOTER //
// ./src/store/configureStore.js